<template>
  <div class="main_style">
    <NavBarHome v-if="navBarStyle === '1'" textColor="#000000" :iconUrl="require('@/assets/img/home/logo-2.png')"/>
    <NavBar v-else />
    <div class="header">
      <div class="header-text">
        <p class="header-title">众享区块链溯源平台</p>
        <p class="header-desc">
          众享区块链溯源平台针对不同标的的特性提供闭环溯源解决方案，结合物联网、大数据、人工智能等先进技术，关键环节可采用物联网技术保证信息的自动生成和上链，降低人力成本的同时为上链数据的真实性提供技术保证手段。
        </p>
      </div>
    </div>
    <!-- 产品介绍 -->
    <div class="intro">
      <div class="commom-title">产品介绍</div>
      <div class="intro-content">
        <p>
          众享区块链溯源平台基于众享科技成熟开源的区块链底层设计，面向政府、企业、认证等各类型溯源行业组织，提供安全、可信、易用的信息录入、设备管理、监管报送、溯源查询服务，改变目前溯源方式普遍存在的消费者不信任、企业不积极、监管手段缺失等问题。<br/><br/>众享区块链溯源平台针对不同标的的特性提供闭环溯源解决方案，结合物联网、大数据、人工智能等先进技术，关键环节可采用物联网技术保证信息的自动生成和上链，降低人力成本的同时为上链数据的真实性提供技术保证手段。
        </p>
      </div>
    </div>
    <!-- 核心功能 -->
    <div class="function">
      <div class="commom-title">核心功能</div>
      <div class="content">
        <el-row :gutter="24" class="grid">
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/Traceability/function-1.png"
                />
              </div>
              <div class="title">溯源平台</div>
              <div class="text">
                搭建溯源链、联盟方和企业注册需溯源平台审核、 给企业产品生成溯源码，查看链上日志信息，查看链上区块信息并监控，发布溯源合约
              </div>
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/Traceability/function-2.png"
                />
              </div>
              <div class="title">联盟方</div>
              <div class="text">
                在溯源平台的基础上搭建节点，对注册的企业进行审核， 查看链上日志信息，可以查看链上区块信息并进行监控， 并发布溯源合约
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/Traceability/function-3.png"
                />
              </div>
              <div class="title">企业</div>
              <div class="text">
                申请产品溯源，对产品进行溯源
              </div>
            </div>
          </el-col>
					<el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/Traceability/function-4.png"
                />
              </div>
              <div class="title">监管方</div>
              <div class="text">
                对企业进行溯源的产品进行审核，审核通过后溯源平台才能分配溯源码
              </div>
            </div>
          </el-col>
					<el-col :span="8">
            <div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/Traceability/function-5.png"
                />
              </div>
              <div class="title">消费者</div>
              <div class="text">
                对产品进行扫码溯源
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 产品架构 -->
    <div class="framework">
      <div class="commom-title">产品架构</div>
      <div class="framework-content">
        <img src="https://image.peerfintech.cn/peerfintech_website_v2/product/Traceability/framework.png" />
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="advantage">
      <div class="commom-title">产品优势</div>
      <div class="advantage-content">
        <el-row :gutter="24">
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/Traceability/advantage-1.png"
                />
              </div>
              <div class="title">真实可信的价值数据</div>
              <div class="text">
								区块链溯源闭环生态利用物联网、区块链等多种手段组合保证数据的真实性，提升数据的应用价值，向消费者、行业企业、职能机构提供真实可信的数据服务
              </div>
            </div></el-col
          >
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/Traceability/advantage-2.png"
                />
              </div>
              <div class="title">自动运营 降本增效</div>
              <div class="text">
                从生产端到消费端形成闭环生态，利用物联网、区块链智能合约等实现数据自动上链，自动运营，减少人工，降低人为误差和人力成本，提高效率
              </div>
            </div></el-col
          >
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/Traceability/advantage-3.png"
                />
              </div>
              <div class="title">质优价廉的金融服务</div>
              <div class="text">
                可引入金融机构向供应链上的企业提供授信和质押等金融服务，满足企业不同阶段的融资贷款需求
              </div>
            </div></el-col
          >
          <el-col :span="12"
            ><div class="grid-content">
              <div class="img">
                <img
                  src="@/assets/img/product/Traceability/advantage-4.png"
                />
              </div>
              <div class="title">与现有系统快速集成</div>
              <div class="text">
                针对不同安全边界设计可信、可用的溯源模式，方便各类主体使用
              </div>
            </div></el-col
          >
        </el-row>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import NavBar from "@/components/NavBar";
import NavBarHome from "@/components/NavBarHome";
import Footer from "@/components/Footer";
import {scrollMixin} from '@/mixins/scroll.js'
export default {
  mixins: [scrollMixin],
  components: {
    NavBar,
    NavBarHome,
    Footer,
  },
  mounted() {
    // 页面回退顶部
    window.scrollTo(0, 0);
  },
};
</script>
<style lang="scss" scoped>
.main_style {
  background-color: #ffffff;
  .content-width {
    width: 1200px;
    margin: 0px auto;
  }
  .commom-title {
    padding: 70px 0px 50px;
    font-size: 32px;
    font-family: "PingFangSC-Medium";
    color: rgba(0, 0, 0, 0.85);
    line-height: 45px;
    text-align: center;
  }
  .header {
    width: 100%;
    height: 540px;
    background: url("https://image.peerfintech.cn/peerfintech_website_v2/product/Traceability/bg.png")
      center/cover no-repeat;
    .header-text {
      @extend .content-width;
      .header-title {
        font-size: 36px;
        font-family: "PingFangSC-Medium";
        color: #000000;
        line-height: 50px;
        padding-top: 160px;
      }
      .header-desc {
        width: 510px;
        color: rgba(0,0,0,0.75);
        font-size: 20px;
        line-height: 33px;
        margin-top: 36px;
      }
    }
  }
  .intro {
    padding-bottom: 70px;
    .intro-content {
      @extend .content-width;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 25px;
    }
  }
  .function {
    background: #f4f7fc;
    .content {
      @extend .content-width;
      padding-bottom: 20px;
      .line-title {
        display: flex;
        width: 100%;
        align-items: center;
        margin-bottom: 24px;
        div:nth-child(2) {
          padding: 0px 77px;
          font-size: 26px;
          color: #0075ff;
          line-height: 37px;
        }
        div:nth-child(1),
        div:nth-child(3) {
          flex: 1;
          height: 1px;
          background: #0075ff;
        }
      }
      .grid {
        padding-bottom: 26px;
        .grid-content {
          height: 352px;
          margin-bottom: 24px;
          background: #ffffff;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 42px 24px 0px;
          .img {
            width: 124px;
            height: 124px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .title {
            padding: 24px 0px;
            font-size: 22px;
            font-family: "PingFangSC-Medium";
            color: rgba(0, 0, 0, 0.85);
            line-height: 30px;
          }
          .text {
            font-size: 16px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 22px;
            text-align: center;
          }
        }
      }
    }
  }
  .framework {
    padding-bottom: 70px;
    .framework-content {
      @extend .content-width; 
      img {
        width: 100%;
      }
    }
  }
  .advantage {
    background: #f4f7fc;
    .advantage-content {
      @extend .content-width;
      padding-bottom: 70px;
      .el-row {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
      .grid-content {
        height: 370px;
        background: #ffffff;
        box-shadow: 3px 3px 15px 0px rgba(0, 0, 0, 0.1);
        padding: 40px 48px 0px 40px;
        .img {
          width: 124px;
          height: 124px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          padding: 24px 0px;
          font-size: 22px;
          font-family: "PingFangSC-Medium";
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
        }
        .text {
          font-size: 16px;
          color: rgba(0, 0, 0, 0.45);
          line-height: 22px;
        }
      }
    }
  }
  .project {
    .project-content {
      @extend .content-width;
      padding-bottom: 70px;
      .grid-content {
        height: 194px;
        background: #f4f7fc;
        display: flex;
        flex-direction: column;
        align-items: center;
				padding:24px 48px 0px;
        .img {
          width: 66px;
          height: 66px;
          margin-bottom: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .title {
          font-size: 22px;
          color: rgba(0, 0, 0, 0.85);
          line-height: 30px;
					text-align: center;
        }
      }
      .el-row {
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    
  }
}
</style>
